import {useCallback, useEffect, useState} from 'react';

export function useManualTimeout(timeoutDelayMs: number | null) {
  const [hasTimedOut, setHasTimedOut] = useState(false);

  const run = useCallback(
    function runTimer() {
      setHasTimedOut(false);

      if (timeoutDelayMs === null) {
        return;
      }

      const timeout = setTimeout(() => {
        setHasTimedOut(true);
      }, timeoutDelayMs);

      return () => {
        clearTimeout(timeout);
        setHasTimedOut(false);
      };
    },
    [timeoutDelayMs],
  );

  return [hasTimedOut, run] as const;
}

export const useTimedOut = (timeoutDelayMs: number | null) => {
  const [hasTimedOut, run] = useManualTimeout(timeoutDelayMs);

  useEffect(() => {
    const clear = run();
    return clear;
  }, [run]);

  return hasTimedOut;
};
